<template>
  <FormKit
    type="form"
    :value="{
      birthdate:'',
      rg_fathers_name:'',
      rg_mothers_name:'',
      gender:'',
    }"
    submit-label="Continuar"
    @submit="confirmData"
  >

    <h2 class="text-xl font-bold mb-1">Insira seus dados</h2>
    <FormKit
      name="birthdate"
      type="date"
      label="Sua data de nascimento*"
      validation="required"
      :validation-messages="{
          required: 'A data de nascimento é obrigatória',
        }"
    />
    <FormKit
      type="text"
      name="rg_fathers_name"
      id="fathers_name"
      label="Nome do pai completo sem abreviação"
    />
    <FormKit
      type="text"
      name="rg_mothers_name"
      label="Nome da mãe completo sem abreviação*"
    />
    <FormKit
      type="select"
      name="gender"
      label="Qual o seu gênero?*"
      placeholder="Selecione uma opção"
      validation="required"
      :validation-messages="{
        required: 'Selecionar seu gênero é obrigatório'
      }"
      :options = "[
        { label: '', value: '' },
        { label: 'Masculino', value: 'male' },
        { label: 'Feminino', value: 'female' },
        { label: 'Outro', value: 'other' },
      ]"
    />
    <template #submit>
      <FooterButton/>
    </template>

  </FormKit>
</template>

<script>
  import FooterButton from '../../components/FooterButton.vue';
  import HeaderTitle from '@/cadastro/components/HeaderTitle.vue';
  import { useStore } from '../../../stores/cadastro.js'
  import { useRouter } from 'vue-router'

  export default {
    components: {
      FooterButton,
      HeaderTitle
    },
    setup() {
      const store = useStore();
      const router = useRouter();

      const confirmData = async (formData) => {
        await store.updatePersonalData(formData);
        router.push({ name: 'AddressForm' })
      }
      return {
        confirmData
      };
    },
    data() {
      return {
        birth_date:'',
        rg_fathers_name:'',
        rg_mothers_name:'',
        gender:'',
      }
    }
  }
</script>


